import React, { createContext, useContext, useState, ReactNode } from 'react';

interface VerificationStatusContextType {
  status: string | null;
  setStatus: (status: string) => void;
  isLoading: boolean;
  setIsLoading: (loading: boolean) => void;
  rejectionReason: string | null;
  setRejectionReason: (reason: string) => void;
}

const VerificationStatusContext = createContext<VerificationStatusContextType | undefined>(undefined);

export const VerificationStatusProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [status, setStatus] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [rejectionReason, setRejectionReason] = useState<string | null>(null);

  return (
    <VerificationStatusContext.Provider value={{ status, setStatus, isLoading, setIsLoading, rejectionReason, setRejectionReason }}>
      {children}
    </VerificationStatusContext.Provider>
  );
};

export const useVerificationStatus = () => {
  const context = useContext(VerificationStatusContext);
  if (!context) {
    throw new Error('useVerificationStatus must be used within VerificationStatusProvider');
  }
  return context;
};
